<script setup lang="ts">
import type { FormProps, FormInstance } from 'ant-design-vue';
import { ref } from 'vue';

const props = withDefaults(defineProps<FormProps>(), {
  hideRequiredMark: true,
  layout: 'vertical',
});

const formRef = ref<FormInstance>();
defineExpose({
  validate: () => formRef.value?.validate(),
  validateFields: (fields?: string[]) => formRef.value?.validateFields(fields),
  resetFields: () => formRef.value?.resetFields(),
  clearValidate: () => formRef.value?.clearValidate(),
  scrollToField: (name: string | string[]) =>
    formRef.value?.scrollToField(name),
  // Expose the form instance directly for debugging
  formInstance: () => formRef.value,
});
</script>

<template>
  <a-form ref="formRef" v-bind="props">
    <slot></slot>
  </a-form>
</template>
